<div class="date-input range-datepicker d-flex p-0">
    <div class="input-group ps-2">
        <input id="rangeDatePicker" name="datepicker" class="input-calendar" placeholder="dd/mm/yyyy - dd/mm/yyyy"
            ngbDatepicker [value]="inputDate" #datepicker="ngbDatepicker" [autoClose]="'outside'"
            (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="dayTemplate"
            [footerTemplate]="footerTemplate" outsideDays="hidden" [startDate]="fromDate!" tabindex="-1"
            readonly="true" />
        <!-- [maxDate]="displayMonths == 1? getMaxSelectableDate():null" -->
        <!-- [value]="inputDate" -->
        <div class="px-2 calender-2 cursorPointer border-end d-flex align-items-center">
            <img src="./../../../../assets/svg/datepicker-icon.svg" (click)="datepicker.toggle()" alt="">
        </div>

        <ng-template #dayTemplate let-date let-focused="focused" (mouseleave)="leave()">
            <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                [class.start-date]="isStartDate(date)" [class.end-date]="isEndDate(date)"
                [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date ;"
                (mouseleave)="hoveredDate = null">
                {{ date.day }}
            </span>
        </ng-template>
        <!-- Templates -->
        <ng-template #footerTemplate>
            <hr class="my-0">
            <div class="action-buttons">
                <button class="btn btn-sm btn-gray text-nowrap cursorPointer " (click)="onClear()">Clear</button>
                <button class="btn btn-sm btn-blue text-nowrap cursorPointer " (click)="onApply()"
                    [disabled]="!inputDate">Apply</button>
            </div>
        </ng-template>
        <!-- end Templates -->
    </div>
</div>